import { render, staticRenderFns } from "./DropdownSearchItem.vue?vue&type=template&id=835a6a5a"
import script from "./DropdownSearchItem.vue?vue&type=script&lang=js"
export * from "./DropdownSearchItem.vue?vue&type=script&lang=js"
import style0 from "./DropdownSearchItem.vue?vue&type=style&index=0&id=835a6a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports